module.exports = __webpack_public_path__ + "img/logout.original.a1198ccd.svg";